import React from 'react';
import PropTypes from 'prop-types';
import '../../Task.scss';
import InsertMixingTask from './InsertMixingTask';
import MixingTaskDetails from './MixingTaskDetails';

function MixingTask({
  task,
  runtimeMode,
  readOnly,
  executionStatus,
  onShowMenuContext,
  onDelete,
  onCheckedChange,
  onSelectTask,
  card,
  // #region dragging business
  onDrag,
  isDragging,
  disableDrag,
  // #endRegion dragging business
  excludedComponentRef,
}) {
  if (!task.labwareID) {
    return (
      <InsertMixingTask
        onDelete={onDelete}
        isSelected={task.isSelected}
        isDragging={isDragging}
        runtimeMode={runtimeMode}
        task={task}
        excludedComponentRef={excludedComponentRef}
      />
    );
  }

  return (
    <MixingTaskDetails
      task={task}
      runtimeMode={runtimeMode}
      readOnly={readOnly}
      executionStatus={executionStatus}
      onShowMenuContext={onShowMenuContext}
      onDelete={onDelete}
      onCheckedChange={onCheckedChange}
      onSelectTask={onSelectTask}
      card={card}
      // #region dragging business
      onDrag={onDrag}
      isDragging={isDragging}
      disableDrag={disableDrag}
    />
  );
}

MixingTask.propTypes = {
  runtimeMode: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
  executionStatus: PropTypes.string.isRequired,
  onDrag: PropTypes.func.isRequired,
  disableDrag: PropTypes.bool.isRequired,
  isDragging: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
  onCheckedChange: PropTypes.func.isRequired,
  onShowMenuContext: PropTypes.func.isRequired,
  onSelectTask: PropTypes.func.isRequired,
  card: PropTypes.object,
  task: PropTypes.object.isRequired,
  excludedComponentRef: PropTypes.array,
};

MixingTask.defaultProps = {
  card: {},
  excludedComponentRef: [],
};

export default MixingTask;
